export const TEAMS_FA = {
    
}